import { useHead } from '../lib/head.js'
import { site } from '../data/site.js'

// Per-page SEO tags. Usage: <Seo title="Services" description="..." path="/services" />
export default function Seo({ title, description, path = '', image, noIndex = false }) {
  /* Several pages already end their title with the company name, which was
     producing "About — Spectranox — Spectranox" in the tab and in every
     search result. Only append it when it is not already there. */
  const fullTitle = !title
    ? `${site.name} — ${site.tagline}`
    : title.includes(site.name)
      ? title
      : `${title} — ${site.name}`
  const desc = description || site.description

  /* The origin the page is actually being served from, not a constant.
     site.url is only the fallback for the brief server-side/prerender moment
     when there is no window -- and the prerender writes its own tags anyway. */
  const origin =
    typeof window !== 'undefined' && window.location?.origin
      ? window.location.origin
      : site.url

  const url = `${origin}${path}`
  /* Absolute, because social scrapers do not resolve relative paths. */
  const ogImage = image
    ? (image.startsWith('http') ? image : `${origin}${image}`)
    : `${origin}/images/spectranox.webp`
  const robots = noIndex
    ? 'noindex, nofollow'
    : 'index, follow, max-image-preview:large, max-snippet:-1'

  useHead([
    { tag: 'title', text: fullTitle },
    { tag: 'meta', attrs: { name: 'description', content: desc } },
    { tag: 'link', attrs: { rel: 'canonical', href: url } },
    { tag: 'meta', attrs: { name: 'robots', content: robots } },
    { tag: 'meta', attrs: { property: 'og:site_name', content: site.name } },
    { tag: 'meta', attrs: { property: 'og:title', content: fullTitle } },
    { tag: 'meta', attrs: { property: 'og:description', content: desc } },
    { tag: 'meta', attrs: { property: 'og:url', content: url } },
    { tag: 'meta', attrs: { property: 'og:type', content: 'website' } },
    { tag: 'meta', attrs: { property: 'og:locale', content: 'en_IN' } },
    { tag: 'meta', attrs: { property: 'og:image', content: ogImage } },
    { tag: 'meta', attrs: { name: 'twitter:card', content: 'summary_large_image' } },
    { tag: 'meta', attrs: { name: 'twitter:title', content: fullTitle } },
    { tag: 'meta', attrs: { name: 'twitter:description', content: desc } },
    { tag: 'meta', attrs: { name: 'twitter:image', content: ogImage } },
  ])

  return null
}
